'use client';

import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';
import { ArrowUpRight, BookOpen, CircleHelp, Wrench } from 'lucide-react';

const quickStartIconMap = {
  gettingStarted: BookOpen,
  howTo: Wrench,
  faq: CircleHelp,
} as const;

export function KBQuickStart({ className = '' }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <section className={`rounded-xl border border-gray-200 bg-white shadow-sm ${className}`}>
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-3">
        <h2 className="text-sm font-semibold text-gray-900">{t.knowledgeBase.home.quickStart.title}</h2>
      </div>

      <div className="grid gap-3 p-5 md:grid-cols-3">
        {t.knowledgeBase.home.quickStart.items.map((item) => {
          const Icon = quickStartIconMap[item.id as keyof typeof quickStartIconMap] ?? BookOpen;

          return (
            <Link
              key={item.id}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="rounded-lg border border-gray-200 bg-white p-4 transition-all hover:border-blue-200 hover:shadow-sm">
                <div className="mb-3 flex items-center justify-between">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-blue-50">
                    <Icon className="h-4 w-4 text-blue-600" />
                  </span>
                  <ArrowUpRight className="h-4 w-4 text-gray-400 transition-colors group-hover:text-blue-600" />
                </div>
                <h3 className="text-sm font-medium text-gray-900 group-hover:text-blue-600">{item.title}</h3>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
